export default __webpack_public_path__ + "static/media/view.cb27a984.svg";